export var SpaceTable;
(function (SpaceTable) {
    let GitRepositoryType;
    (function (GitRepositoryType) {
        GitRepositoryType.map = {};
        GitRepositoryType.Github = 10;
        GitRepositoryType.map[GitRepositoryType.Github] = "Github";
        GitRepositoryType.AzureRepos = 20;
        GitRepositoryType.map[GitRepositoryType.AzureRepos] = "Azure Repos";
        GitRepositoryType.Unknown = 90;
        GitRepositoryType.map[GitRepositoryType.Unknown] = "不明";
    })(GitRepositoryType = SpaceTable.GitRepositoryType || (SpaceTable.GitRepositoryType = {}));
})(SpaceTable || (SpaceTable = {}));
